import { IImportControl, IConfigControlImport } from '@se/cp.common';
import { DataBinding } from '@se/se.ui.html5';

import { CpControl } from './cp-control';
import { IImportDataBinding } from './import-abstractions';

export class CpImportControl extends CpControl {
    readonly controlTypeGroup = 'Import';

    maxReturnedExams: number;
    onlyOnSameDataset: boolean;
    onlyOnSameLayout: boolean;
    icon: string;
    iconTooltip: string;
    dataBindings!: IImportDataBinding[];

    constructor(control: IImportControl, dataBindingContext?: DataBinding) {
        super(control);

        this.maxReturnedExams = control.maxReturnedExams;
        this.onlyOnSameDataset = control.onlyOnSameDataset;
        this.onlyOnSameLayout = control.onlyOnSameLayout ?? false;
        this.icon = control.icon;
        this.iconTooltip = control.iconTooltip;
        this.setDataBinding(control.config, dataBindingContext);
    }

    canAlignToBottom() {
        return false;
    }

    getHeightHint() {
        return 51;
    }

    protected setDataBinding(configControl: IConfigControlImport[], context?: DataBinding) {
        this.dataBindings = [];

        configControl.forEach((config) => {
            const dataBindingSource = new DataBinding(config.dataBinding, context);
            let dataBindingTarget = null;

            if (!!config.dataBindingTarget) {
                dataBindingTarget = new DataBinding(config.dataBindingTarget, context);
            } else {
                dataBindingTarget = new DataBinding(config.dataBinding, context);
            }

            const gridHeader = config.gridHeader;
            const gridVisibleProp = config.gridVisibleProp;

            this.dataBindings.push({ dataBindingSource, dataBindingTarget, gridHeader, gridVisibleProp });
        });
    }
}
